import { createContext, useContext, type ReactNode } from 'react';
import { useNetworkStatus } from '@/mobile/hooks/useNetworkStatus';
import type { NetworkStatus } from '@/mobile/services/network.service';

const NetworkStatusContext = createContext<NetworkStatus>({
  connected: true,
  connectionType: 'unknown',
});

export function NetworkStatusProvider({ children }: { children: ReactNode }) {
  const status = useNetworkStatus();
  return (
    <NetworkStatusContext.Provider value={status}>{children}</NetworkStatusContext.Provider>
  );
}

export function useNetworkStatusContext(): NetworkStatus {
  return useContext(NetworkStatusContext);
}
